type valueOf<O> = O[keyof O];
type RouteConstant = valueOf<typeof import('@/constants/routes')>;
type RoutesFeatureFlags = Partial<Record<RouteConstant, boolean>>;

export const routesFeatureFlags = (): RoutesFeatureFlags => ({
  /**
   * Example: The portfolio route would only be available in local development
   * [ROUTE_PORTFOLIO]: SWS_ENV === 'local',
   */
});
